import type { TranslationMessages } from '../types';

export const inventory: TranslationMessages = {
  name: 'Inventory',
  add: 'Add Inventory',
  scanQR: 'Scan QR Code',
  edit: 'Edit Inventory',
  deleteAction: 'Delete Inventory',
  create: 'Create Inventory',
  editDescription: 'Update inventory item details',
  createDescription: 'Add a new inventory item to the system',
  list: 'Inventory List',
  search: 'Search inventory...',
  warehouse: {
    name: 'Warehouse',
    placeholder: 'Select warehouse',
  },
  category: {
    name: 'Category',
    placeholder: 'Select category',
  },
  ingredient: {
    name: 'Ingredient',
    placeholder: 'Select ingredient (optional)',
    none: 'No ingredient',
    quickCreate: 'Quick create ingredient',
  },
  product: {
    name: 'Product',
    placeholder: 'Select product (optional)',
    none: 'No product',
    help: 'Select a product for basic items (e.g., Fanta, Surprise, Pepsi). Leave empty if linked to ingredient.',
    searchPlaceholder: 'Search products...',
  },
  filter: 'Filter',
  clear: 'Clear',
  all: 'All',
  status: 'Status',
  price: 'Price',
  basicInfo: 'Basic Information',
  quantityPricing: 'Quantity & Pricing',
  dimensions: 'Package Dimensions',
  fields: {
    code: 'Code',
    codePlaceholder: 'Enter inventory code',
    name: 'Name',
    description: 'Description',
    quantity: 'Quantity',
    totalPrice: 'Total Price',
    currency: 'Currency',
    width: 'Width (cm)',
    height: 'Height (cm)',
    weight: 'Weight',
    volume: 'Volume',
    isPackage: 'Is Package',
    namePlaceholder: 'Enter inventory name',
    descriptionPlaceholder: 'Enter inventory description',
    itemCount: 'Item count per package',
    itemCountPlaceholder: 'e.g., 12',
    itemCountHelp:
      'Optional: Number of individual items contained in each package',
    quantityAnchor: 'Stock tracking attribute',
    quantityAnchorPlaceholder: 'Select attribute (optional)',
    quantityAnchorHelp:
      'Select an attribute to use for automatic quantity calculation. When set, quantity will be calculated from remaining values and cannot be manually edited.',
    noAnchor: 'No attribute (enter quantity manually)',
    anchorItemCount: 'Item count',
    anchorWeight: 'Weight',
    anchorVolume: 'Volume',
    calculated: 'Calculated',
    quantityHelp:
      'Total items: {total} ({quantity} packages × {itemCount} items)',
    quantityCalculatedHelp:
      'Quantity is automatically calculated from selected attribute',
    currentStock:
      'Current stock: {total} items ({quantity} packages × {itemCount} items/package)',
    currentQuantity: 'Current quantity: {quantity}',
    updateStock: 'Update Stock',
    remainingItems: 'Remaining item count',
    remainingItemsHelp:
      'Total remaining item count. Quantity will be calculated as: remaining items / items per package',
    remainingWeight: 'Remaining weight',
    remainingWeightHelp:
      'Total remaining weight. Quantity will be calculated as: remaining weight / weight per package',
    remainingVolume: 'Remaining volume',
    remainingVolumeHelp:
      'Total remaining volume. Quantity will be calculated as: remaining volume / volume per package',
  },
  code: 'Code',
  quantity: 'Quantity',
  totalPrice: 'Total Price',
  currency: 'Currency',
  scanQrCode: 'Scan Inventory QR Code',
  scannerReady: 'Scanner Ready',
  scanning: 'Scanning...',
  processing: 'Processing...',
  scannerInstructions: 'Scanner Instructions',
  pointCamera: 'Point camera at inventory QR code',
  ensureGoodLighting: 'Ensure good lighting',
  holdSteady: 'Hold camera steady until scan completes',
  invalidQRFormat:
    'Invalid QR code format. Please scan an inventory QR code.',
  customerQRDetected:
    'This QR code is for customer check-in, not inventory management',
  qrProcessingFailed: 'Failed to process QR code',
  scannerError: 'Scanner Error',
  messages: {
    created: 'Inventory item created successfully',
    updated: 'Inventory item updated successfully',
    deleted: 'Inventory item deleted successfully',
    error_creating: 'Error creating inventory item',
    error_updating: 'Error updating inventory item',
    error_deleting: 'Error deleting inventory item',
    error_loading: 'Error loading inventory list',
    confirm_delete: 'Are you sure you want to delete this inventory item?',
  },
  qrCode: 'QR Code',
  printQR: 'Print QR Code',
  provider: {
    name: 'Provider',
    placeholder: 'Select provider (optional)',
    none: 'No provider',
  },
  deleteTitle: 'Delete Inventory Item',
  delete: {
    message:
      'Are you sure you want to delete this inventory item? This action cannot be undone.',
  },
  qrCodeManager: 'QR Code Manager',
  currentQuantity: 'Current Quantity',
  generating: 'Generating...',
  generate: 'Generate',
  downloadQR: 'Download QR Code',
  scanQRCode: 'Scan QR Code',
  scan: 'Scan',
  generateQRCode: 'Generate QR Code',
  scanInstructions: 'Scan Instructions',
  scanForCounting: 'Scan for inventory counting',
  scanForDeduction: 'Scan for stock deduction',
  scanForAdjustment: 'Scan for stock adjustment',
  noWarehouses: 'No warehouses available',
  noCategories: 'No categories available',
  noFieldsAvailable: 'No fields available',
  anchorActive: 'Anchor Active',
  anchorInfo: 'Anchor Info',
};
